import React from "react";
import { CTAButton } from "./CTAButton";
type SectionCTAProps = {
  label: string;
  note?: string;
  tone?: "dark" | "light";
};
export function SectionCTA({
  label,
  note = "Instant access · One-time payment of $27",
  tone = "light"
}: SectionCTAProps) {
  return <div className="mx-auto mt-12 flex max-w-xl flex-col items-center md:mt-14" data-id="element-317" data-mp="1lf7jdqcivm4t">
      <CTAButton label={label} data-id="element-318" data-mp="1qe0uxd89132c" />
      <p className={`mt-4 text-center text-sm font-medium ${tone === "dark" ? "text-brand-200" : "text-muted"}`} data-id="element-319" data-mp="1bna1k0r0dvx4">
        {note}
      </p>
    </div>;
}